import { Card as ProCard } from './components/card';
import { CardSection } from './components/card-section';
ProCard.CardSection = CardSection;
export default ProCard;